import { CDN_BASE_URL } from "@/config/config";
export var remoteImg = function remoteImg(path) {
  return CDN_BASE_URL.remoteImg + path;
}; // This exports the plugin object.

export var plugin = {
  install: function install(Vue, options) {
    Vue.prototype.$remoteImg = remoteImg;
  }
};